import * as React from 'react';

import Box from '@mui/material/Box';

import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportTypeCalendar from './Bs4ReportTypeCalendar';
import { HideOnScroll, useScrollTarget} from '../Bs4Components/HideOnScroll';
import {   
  TYPE_NAVIGATION,
  TYPE_SCHEDULER,
  TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,
  VIEW_TYPE_AGENDE,

  ATRYBUT_SCHED_SHOWYEAR,
  ATRYBUT_SCHED_SHOWMONTH,
  ATRYBUT_SCHED_SHOWWEEK,
  ATRYBUT_SCHED_SHOWDAY,
  ATRYBUT_SCHED_SHOWAGENDE,

  VIEW_TYPE_MODIFIER_HOURS_MIN_MAX,

  footerButtons,
} from './Bs4ReportCalendar/Bs4ReportCalendarConst';
import Bs4ReportCalendar from './Bs4ReportCalendar/Bs4ReportCalendar';
import Bs4ReportCalendarPlanning from './Bs4ReportCalendar/Bs4ReportCalendarPlanning';
import Bs4I18N from '../Bs4I18N';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import { getBoxSx, UxAccordion, useStateUxTemplate, UXTEMPLATE } from '../Bs4Theme/Bs4UxTemplates';
import Bs4ReportCalendarPlanningUx from '../Bs4Theme/Bs4UxTemplateEditors/Bs4ReportCalendarPlanningUx';
import Bs4ReportCalendarUx from '../Bs4Theme/Bs4UxTemplateEditors/Bs4ReportCalendarUx';

const TYPE_BS4REPORT = 'type_Bs4Reporttype42';
const TYPE_BS4REPORTTYPE42_HOUR_RANGE = 'type_Bs4Reporttype42_hour_range';

//Kalendarz
export default class Bs4ReportType42 extends Bs4ReportTypeCalendar {

  createModel() {        
    super.createModel();
    this.initialValues = {};
    // this.initialValues.bs4rowheight = this.getPageParam('bs4rowheight') || null;
    // this.initialValues.leftColumnWidth = this.getPageParam('leftColumnWidth') || 150;     
    // this.initialValues.bs4axisName = this.getPageParam('bs4axisName')
    this.initialValues.allowaddevent = Boolean(this.getPageParam('allowaddevent') === 1);
    this.initialValues.minInterval = parseInt(this.getPageParam('min_interval')) || 5;
    this.initialValues.hoursMinSec = parseInt(this.getPageParam('hours_min')) || null;
    this.initialValues.hoursMaxSec = parseInt(this.getPageParam('hours_max')) || null;
    this.initialValues.bs4FormField = this.props.bs4FormField;
    this.initialValues.formId = this.props.formId;    
    
    this.viewButtons = {};
    this.viewButtons[VIEW_TYPE_YEAR] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWYEAR) === 1);
    this.viewButtons[VIEW_TYPE_MONTH] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWMONTH) === 1);
    this.viewButtons[VIEW_TYPE_WEEK] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWWEEK) === 1);
    this.viewButtons[VIEW_TYPE_DAY] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWDAY) === 1);
    this.viewButtons[VIEW_TYPE_AGENDE] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWAGENDE) === 1);
    this.viewButtons[VIEW_TYPE_MODIFIER_HOURS_MIN_MAX] = false;
  

    const bs4schscope = this.getPageParam('bs4schscope');    
    try {
      const bs4schscopeJson = JSON.parse(bs4schscope);
      this.initialValues.viewType = bs4schscopeJson.DateScope;      
    } catch(error) {
      this.initialValues.viewType = bs4schscope;
    }                    
      
    if (this.props.optionType === '1000024') {
      this.bs4ReportCalendar = new Bs4ReportCalendarPlanning(this.initialValues, this.viewButtons);
    } else {
      this.bs4ReportCalendar = new Bs4ReportCalendar(this.initialValues, this.viewButtons);
    }    

    this.bs4ReportCalendar.bs4KartotekaId = this.props?.bs4KartotekaId;
    this.reloadAll = () => {
      this.bs4ReportCalendar.reload()
    }
  }

  createBs4UxTemplate = () => {
    if (this.props.optionType === '1000024') {
      this.bs4UxTemplate = new Bs4ReportCalendarPlanningUx(this.props.optionType, this.getPageParam(UXTEMPLATE), this.optionId);
    } else {
      this.bs4UxTemplate = new Bs4ReportCalendarUx(this.props.optionType, this.getPageParam(UXTEMPLATE), this.optionId);;
    }
  }

  setUxTemplate = (id) => {
    if (!this.bs4UxTemplate) this.createBs4UxTemplate();
    if (!id) id = this.getPageParam(UXTEMPLATE);
    this.bs4UxTemplate.setUxTemplate(id);
  }

  getUxTemplateEditor = (uxEditor) => {
    if (!this.bs4UxTemplate) this.createBs4UxTemplate();
    return this.bs4UxTemplate.getUxTemplateEditor(uxEditor);
  }
  
  getInitScope() {
    try {
      const bs4schscope = JSON.parse(this.getPageParam('bs4schscope'));
      const viewInitType = bs4schscope.DateScope;
      let footerButtons = this.footerButtons.filter(view => this.isSelected(this.bs4UxTemplate.uxTemplate.body?.Report42?.footer, view, Bs4ReportType42.TYPE_AGENDE));
      const viewInitTypeA = footerButtons.find(view => view.viewType === viewInitType);
      if (viewInitTypeA) return viewInitTypeA.viewType;

      footerButtons = this.footerButtons.filter(view => this.isSelected(this.bs4UxTemplate.uxTemplate.body?.Report42?.footer, view, Bs4ReportType42.TYPE_CALENDAR));
      const viewInitTypeC = footerButtons.find(view => view.viewType === viewInitType);
      if (viewInitTypeC) return viewInitTypeC.viewType;

      if (footerButtons.length > 0) return footerButtons[0].viewType;      
    } catch (error) {
      console.log(error);
    }

    return null;
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;    
    const setScrollTarget = useScrollTarget(this.optionId, props.formField);
    const {dateTimeStamp: uxDateTimeStamp} = useStateUxTemplate(this.bs4UxTemplate.getType());

    return (
      <Box 
        ref={ref} 
        height='100%' 
        width='100%' 
        display='flex' 
        flexDirection="column" 
        overflow='hidden'
        px={props.uxKartoteka?.spacing}
      >
        <Box flex={1} display='flex' flexDirection="column" overflow='hidden'>
          <HideOnScroll type={report.optionId}>
            <Box display="flex" flexDirection="row" flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
              <Bs4Criteria {...report.props}/>
              <report.bs4ReportCalendar.ViewResources/>
              <report.ReportBs4HorizontalMenu bs4Menu={report.menuItems} var/>
            </Box>
          </HideOnScroll>
          <Box pt={props.uxKartoteka?.spacing / 3}/>
          <Bs4CriteriaSummary {...report.props}/>
          <report.bs4ReportCalendar.ViewComponent 
            columnsMenu={report.columnsMenu}
            // uxBodyEvent={uxBodyEvent}
            // uxBodyFooter={uxBodyFooter}
            // uxBodyOption={uxBodyOption}
            onMenuClick={report.handleMenuClickEvent}
            fetchMore={report.fetchMore}
            onShow={report.handleReportIconShow}
            onRemember={report.handleReportIconRemember}
            onReset={report.handleReportIconReset}
            viewButtons={report.viewButtons}
            onRowClick={report.handleRowClick}
            bs4EventResize={report.handleBs4EventResize}
            bs4EventDrop={report.handleBs4EventDrop}
            bs4EventAdd={report.handleBs4EventAdd}
            setScrollTarget={setScrollTarget}
            uxTemplate={this.bs4UxTemplate.uxTemplate}
            uxDateTimeStamp={uxDateTimeStamp}
          />
        </Box>
      </Box>
    )
  });
}
